import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import Home from './Home';
import {PATHS} from '../components/Footer';
import {pathByLabel} from '../utils/urlPaths';

const Socials = ({
  compactView,
  location: {
    query: {noSecondary}
  },
  ...props
}) => (
  <Home
    {...props}
    mode={{
      header: compactView ? [PATHS.LOGIN_BY_USERNAME] : [],
      primarySocials: true,
      username: false,
      secondarySocials: noSecondary !== 'true',
      otherSocialLink: pathByLabel[PATHS.OTHER_NO_EMAIL],
      footer: []
    }}
  />
);

Socials.propTypes = {
  location: {
    query: {
      noSecondary: 'true' || 'false'
    }
  },
  compactView: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    compactView: state.xl.compactView
  };
}

export default connect(mapStateToProps)(Socials);



// WEBPACK FOOTER //
// ./pages/Socials.jsx